/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import ThumbnailTile from '../ThumbnailTile';
import useConnectItemBrowser from '@broadleaf/admin-components/dist/form/item-browser/hooks/useConnectItemBrowser';

const ItemBrowserThumbnailTile = props => {
  const { state } = useConnectItemBrowser();
  const item = state.entities.items[props.id] || props.item;
  const selected = state.itemsUI.selectedId === item.id;
  return <ThumbnailTile {...props} item={item} selected={selected} />;
};

export default ItemBrowserThumbnailTile;
